import React from "react";
import Button from "../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import InputSearch from "../../../../components/ui/InputSearch/InputSearch";

const checkByOptionsValue = [
  {
    id: "title",
    name: "제목",
  },
  {
    id: "contents",
    name: "내용",
  },
];
function Filter(props) {
  const {
    onFilter,
    onSubmitFilter,
    onResetFilter,
    onChangeSearchByValue,
    filter,
    onChangeSearchBy,
    hasStatus = true,
    checkByOptions = checkByOptionsValue,
    placeholder = "제목",
    marginTop = "mt-8",
    paddingTopSearch = "pt-2",
  } = props;

  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className={`${marginTop} mb-2 rounded-[4px]`}
    >
      <div className={`flex items-center px-5 ${paddingTopSearch} pb-5`}>
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center w-1/2">
            <span className="w-24">검색</span>
            <div className="flex gap-4">
              <Dropdown
                width="w-36"
                placeholder={placeholder}
                options={checkByOptions}
                onClickItem={onChangeSearchBy}
                positionDropdown="top-10"
                textColor="text-black"
              />
              <InputSearch
                onChange={(value) => onChangeSearchByValue(value)}
                padding="pr-[3rem]"
              />
            </div>
          </div>

          <div className="flex items-center gap-[8px] w-1/2">
            <span className="w-12">기간</span>
            <InputDate
              onChange={(value) => onFilter({ ...filter, from: value?.unix() })}
              //   className="w-24 h-10"
              placeholder="날짜선택"
            />
            <span className="text-[#bbbbbb]">-</span>
            <InputDate
              onChange={(value) => onFilter({ ...filter, to: value?.unix() })}
              //   className="w-24 h-10"
            />
          </div>
        </div>
      </div>
      <div className="pb-[12px] w-full border-t border-disable-grey " />
      <div className="pb-[12px] flex justify-center items-center">
        <Button
          onClick={onSubmitFilter}
          className="border border-secondary-grey"
          paddingButton="p-1"
          text="필터 검색"
        />

        <Button
          onClick={onResetFilter}
          className="border border-secondary-grey"
          paddingButton="p-1"
          text="필터 초기화"
        />
      </div>
    </div>
  );
}

export default Filter;
